module.exports = "<img src=\"../assets/images/app-header.jpg\">\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/header/header.component.html
// module id = ./src/app/common/header/header.component.html
// module chunks = main